import React, { useState } from "react";
import logo from "../img/logo.jpg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { BrowserRouter as Router, Link } from "react-router-dom";

function Nav() {
  const [menu, setMenu] = useState(false);
  function toggleMenu() {
    setMenu(!menu);
  }

  return (
    <>
      <nav>
        <div className="container">
          <div className="nav">
            <Router>
              <Link to="/">
                <figure className="nav__logo">
                  <img src={logo} className="nav__logo--img" />
                  <h2 className="nav__logo--name">DiamondPE</h2>
                </figure>
              </Link>
            </Router>
            <div className="nav__info">
              <div className="nav__info--adress">
                diamondpe.us.to:19132 <span className="dot" />
              </div>
              <button className="menu-btn" onClick={toggleMenu}>
                {!menu ? (
                  <FontAwesomeIcon icon="fa-bars" />
                ) : (
                  <FontAwesomeIcon icon="fa-xmark" />
                )}
              </button>
            </div>
          </div>
        </div>
      </nav>
      {menu && (
        <div className="menu">
          <Router>
            <div className="menu__links">
              <a href="https://discord.gg/8S7y3gTPNZ" target="_blank">
                <button className="menu__links--btn">Shop</button>
              </a>
              <Link to="/staff">
                <button className="menu__links--btn">Staff Members</button>
              </Link>
              <a href="https://discord.gg/8S7y3gTPNZ" target="_blank">
                <button className="menu__links--btn">Our Discord</button>
              </a>
            </div>
            <div className="menu__btn">
              <a
                href="https://minecraftpocket-servers.com/server/122269/vote/"
                target="_blank"
              >
                <button className="vote-btn btn">Vote Us</button>
              </a>
            </div>
          </Router>
        </div>
      )}
    </>
  );
}

export default Nav;
